import { useId } from "react";
import { cn } from "@/lib/cn";

interface ProSegmentOption {
  value: string;
  label: string;
}

interface ProSegmentProps {
  options: ProSegmentOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  "aria-label"?: string;
}

function ProSegment({
  options,
  value,
  onChange,
  className,
  "aria-label": ariaLabel,
}: ProSegmentProps) {
  const groupName = useId();

  return (
    <fieldset
      className={cn(
        "seg m-0 inline-flex min-w-0 items-center rounded-full border border-pro-border bg-pro-elevated p-[3px]",
        className,
      )}
    >
      {ariaLabel ? <legend className="sr-only">{ariaLabel}</legend> : null}
      {options.map((option) => {
        const isActive = value === option.value;
        return (
          <label
            key={option.value}
            className={cn(
              "inline-flex cursor-pointer items-center justify-center rounded-full px-3.5 py-[5px] text-[12px] font-semibold leading-none text-pro-text-muted transition-all duration-[120ms]",
              isActive && "active bg-lime text-pro-lime-text-on",
              !isActive && "hover:text-pro-text",
            )}
          >
            <input
              type="radio"
              name={groupName}
              value={option.value}
              checked={isActive}
              className="sr-only"
              onChange={() => onChange(option.value)}
            />
            {option.label}
          </label>
        );
      })}
    </fieldset>
  );
}

export { ProSegment, type ProSegmentOption, type ProSegmentProps };
